var _desc, _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.5 62.5)",
    id: 739976
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 62.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.5 62.5)",
    id: 162598
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(243,236,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-44.5, -34)",
    d: "M 75.4582 5.74307 C 75.4334 5.695 75.3924 5.65734 75.3425 5.63682 C 69.5722 2.98187 63.4827 1.08869 57.2267 0.0046437 C 57.1699 -0.00595263 57.1112 0.00169169 57.0589 0.0264895 C 57.0066 0.0512873 56.9635 0.091976 56.9356 0.142769 C 56.1065 1.65196 55.3537 3.20215 54.6804 4.78743 C 47.9367 3.76087 41.0772 3.76087 34.3335 4.78743 C 33.6557 3.19813 32.8909 1.64755 32.0427 0.142769 C 32.0136 0.0930798 31.9702 0.0533282 31.9183 0.0286915 C 31.8663 0.00405478 31.8082 -0.00432509 31.7514 0.0046437 C 25.4948 1.08641 19.405 2.97974 13.6353 5.63697 C 13.5859 5.65797 13.5443 5.69382 13.5161 5.73958 C 1.97797 23.0186 -1.18276 39.8728 0.367786 56.5183 C 0.372148 56.5591 0.384647 56.5986 0.404539 56.6344 C 0.424431 56.6703 0.45131 56.7018 0.483577 56.727 C 7.20211 61.7155 14.7169 65.5233 22.7072 67.9878 C 22.7634 68.0048 22.8235 68.004 22.8793 67.9857 C 22.9352 67.9673 22.9841 67.9323 23.0194 67.8852 C 24.7356 65.5436 26.2562 63.064 27.5659 60.4717 C 27.5839 60.4361 27.5941 60.3971 27.596 60.3573 C 27.5979 60.3174 27.5913 60.2776 27.5767 60.2405 C 27.5622 60.2034 27.5399 60.1698 27.5115 60.142 C 27.483 60.1141 27.449 60.0926 27.4116 60.0789 C 25.0137 59.1588 22.6922 58.0497 20.469 56.7619 C 20.4286 56.7381 20.3947 56.7047 20.3702 56.6646 C 20.3458 56.6245 20.3315 56.579 20.3288 56.5321 C 20.326 56.4852 20.3348 56.4384 20.3544 56.3957 C 20.3739 56.353 20.4037 56.3158 20.441 56.2874 C 20.9088 55.937 21.3685 55.5758 21.8197 55.2041 C 21.8593 55.1714 21.9072 55.1505 21.958 55.1436 C 22.0088 55.1367 22.0605 55.1442 22.1073 55.1653 C 36.6726 61.8312 52.4416 61.8312 66.8345 55.1653 C 66.8814 55.1429 66.9337 55.1343 66.9852 55.1406 C 67.0368 55.1469 67.0855 55.1677 67.1257 55.2006 C 67.5775 55.5743 68.0384 55.9366 68.508 56.2874 C 68.5455 56.3155 68.5755 56.3525 68.5954 56.395 C 68.6152 56.4375 68.6244 56.4843 68.622 56.5312 C 68.6195 56.5781 68.6056 56.6237 68.5815 56.6639 C 68.5573 56.7042 68.5236 56.7378 68.4834 56.7619 C 66.2653 58.0605 63.9417 59.1689 61.5375 60.0754 C 61.5001 60.0896 61.4662 60.1116 61.438 60.1399 C 61.4097 60.1682 61.3877 60.2022 61.3734 60.2396 C 61.3591 60.277 61.3529 60.317 61.355 60.357 C 61.3572 60.397 61.3678 60.4361 61.3861 60.4717 C 62.7177 63.0496 64.2361 65.5261 65.9291 67.8811 C 65.9634 67.9295 66.0121 67.9657 66.0681 67.9848 C 66.1241 68.0038 66.1847 68.0048 66.2413 67.9874 C 74.2459 65.5312 81.7738 61.7231 88.5008 56.727 C 88.5336 56.703 88.5608 56.6723 88.5808 56.6369 C 88.6008 56.6015 88.613 56.5623 88.6166 56.5218 C 90.4729 37.2779 85.5088 20.5618 75.4582 5.74307 Z M 29.7411 46.3829 C 25.3558 46.3829 21.7425 42.3474 21.7425 37.3912 C 21.7425 32.4351 25.2858 28.3993 29.7411 28.3993 C 34.2312 28.3993 37.8095 32.4702 37.7394 37.3909 C 37.7394 42.3474 34.1961 46.3829 29.7411 46.3829 Z M 59.314 46.3829 C 54.9289 46.3829 51.3156 42.3474 51.3156 37.3912 C 51.3156 32.4351 54.8588 28.3993 59.314 28.3993 C 63.8044 28.3993 67.3826 32.4702 67.3125 37.3909 C 67.3125 42.3474 63.8044 46.3829 59.314 46.3829 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.7e5fd1589d9a74a65240d55b6fee106d.svg";
export { ForwardRef as ReactComponent };